import { COLOR_MID_GRAY } from "../../constants";
import { getColors, isDarkTheme } from "../../utils";

const getStyles = () => {
  const colors = getColors();

  return {
    container: {
      cursor: "pointer",
      display: "flex",
      padding: "16px",
      alignItems: "center",
      gap: "24px",
      alignSelf: "stretch",
      borderRadius: "12px",
      background: colors.paper,
      border: colors.border,
      width: "100%",
      boxSizing: "border-box" as const,
    },

    content: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      gap: "8px",
      flex: "1 0 0",
      width: "100%",
    },

    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      gap: "12px",
      flexWrap: "nowrap" as const,
    },

    left: {
      flex: 1,
      minWidth: 0,
    },

    right: {
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },

    textWrap: {
      wordBreak: "break-word" as const,
      whiteSpace: "normal" as const,
      lineHeight: 1.3,
      textTransform: "none",
    },

    chevron: {
      cursor: "pointer",
      flexShrink: 0,
    },

    title: {
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
      alignSelf: "stretch",
      borderTop: colors.border,
    },

    topBlock: {
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
      borderRadius: "8px",
      background: (theme) => theme.palette.primary.light,
    },

    bottomBlock: {
      display: "flex",
      alignItems: "flex-start",
      alignContent: "flex-start",
      gap: "20px 16px",
      alignSelf: "stretch",
      flexWrap: "wrap",
    },

    shop: {
      display: "flex",
      height: "20px",
      justifyContent: "space-between",
      alignItems: "center",
      alignContent: "center",
      rowGap: "8px",
      alignSelf: "stretch",
      flexWrap: "wrap",
    },

    total: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      alignSelf: "stretch",
    },

    topContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
      alignSelf: "stretch",
      padding: "0 16px 20px 16px",
    },

    date: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },

    status: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },

    orderTypeStyle: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },

    orderTotalContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
    },

    paymentBox: {
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
      alignSelf: "stretch",
      borderTop: colors.border,
    },

    capitalize: {
      textTransform: "capitalize",
    },

    paymentRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      alignSelf: "stretch",
    },

    paymentLabel: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px",
    },

    modalBody: {
      p: 0,
      maxHeight: "85vh",
      height: "auto",
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      position: "sticky",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {},
    },

    scrollButton: {
      position: "absolute",
      bottom: 16,
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: colors.bgwhite,
      borderRadius: "50%",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      width: 44,
      height: 44,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 10,
      transition: "opacity 0.2s",
    },

    orderImagesContainer: {
      display: "flex",
      gap: "6px",
      alignItems: "center",
    },

    orderImage: {
      width: "24px",
      height: "24px",
      borderRadius: "4px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      flexShrink: 0,
    },

    orderBadge: {
      width: "24px",
      height: "24px",
      borderRadius: "8px",
      background: isDarkTheme() ? colors.surfaceSecondary : COLOR_MID_GRAY,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
      userSelect: "none",
    },

    orderRow: {
      display: "flex",
      alignItems: "center",
      flex: "1 0 0",
    },
    shopName: {
      maxWidth: "150px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };
};
export default getStyles;